import React from "react";
import styled from "styled-components";
import {
  Icon,
  IconName,
  Theme,
  colors,
} from "@literati/public-ui-shared-react";

const CLASS_BASE = "plan-selection-message-auto-renew";
export const PlanSelectionMessageAutoRenewClassName = {
  BASE: CLASS_BASE,
} as const;

export interface PlanSelectionMessageAutoRenewProps {
  className?: string;
}

const StyledDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  background: ${colors.mintTint4};
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const PlanSelectionMessageAutoRenew = ({
  className = "",
}: PlanSelectionMessageAutoRenewProps) => {
  const cls = PlanSelectionMessageAutoRenewClassName;
  return (
    <Theme>
      <StyledDiv className={`${cls.BASE} ${className}`}>
        <Icon
          css="margin: 0.0625rem 0 0"
          name={IconName.BOX_RETURN}
          fill="tealShade3"
          width={18}
          height={18}
        />
        <TextContainer>
          <p>
            Memberships auto-renew after your{" "}
            <span css="font-weight: 700">last box</span>.
          </p>
          <p
            css={`
              margin: 0.25rem 0 0;
              font-weight: 700;
            `}
          >
            Flexible Schedule • Cancel Stress Free
          </p>
        </TextContainer>
      </StyledDiv>
    </Theme>
  );
};

export default PlanSelectionMessageAutoRenew;
